import { useState } from 'react';
import { DATA_WELL, GAUGE } from 'reporting-data/constants/chartTypes';
import { isConfigReport, isCustomWidgetReport, isFunnelReport, isJourneyReport, isMultiConfigReport, isRelationalReport, isReportWithExternalDataType, isUnifiedAnalyticsReport, isUnifiedEventsReport } from 'reporting-data/tsTypes/reportTypes';
import { VisualTypes } from 'reporting-snowflake/relational/schema/visual-records';
import { ANALYTICS_ALL_PAGES, ANALYTICS_BROWSER_DETAILS, ANALYTICS_DEVICE_TYPE_DETAILS, ANALYTICS_FORMS, ANALYTICS_GEOLOCATION, ANALYTICS_SOURCES, ANALYTICS_TOPICS, ANALYTICS_UTM_CAMPAIGNS, ANALYTICS_UTM_CONTENTS, ANALYTICS_UTM_MEDIUMS, ANALYTICS_UTM_SOURCES, ANALYTICS_UTM_TERMS, UNIFIED_ADS_CAMPAIGNS, UNIFIED_ADS_NETWORKS } from 'reporting-data/constants/dataTypes';
import { isSearchReport } from 'reporting-data/report/configReportGetters';
import { ErrorBoundary } from 'reporting-ui-components/reports/decorators/ErrorBoundaryDecorator';
import { STANDARD_FIELD_TYPES } from 'reporting-ui-components/lib/report-strategies/shared/constants/fieldTypes';
import { getStandardFieldType } from 'reporting-ui-components/lib/report-strategies/shared/utils/reportGetters';
import { isReportValidForReportGetterStrategy } from 'reporting-ui-components/lib/report-strategies/utils/strategyFetchers';
import SRVDatawellInsightContainer from './SRVDatawellInsightContainer';
import ReportKPIContent from './sections/kpi/ReportKPIContent';
import { hasCustomWidgetKpis } from './sections/kpi/sales-custom-widget-kpis/SalesCustomWidgetKPIContent';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const UA_SRV_DATAWELL_EXCEPTION_LIST = [ANALYTICS_UTM_CAMPAIGNS, ANALYTICS_UTM_CONTENTS, ANALYTICS_UTM_MEDIUMS, ANALYTICS_UTM_SOURCES, ANALYTICS_UTM_TERMS, UNIFIED_ADS_CAMPAIGNS, UNIFIED_ADS_NETWORKS, ANALYTICS_SOURCES, ANALYTICS_ALL_PAGES, ANALYTICS_DEVICE_TYPE_DETAILS, ANALYTICS_FORMS, ANALYTICS_GEOLOCATION, ANALYTICS_BROWSER_DETAILS, ANALYTICS_TOPICS];
const EXTERNAL_DATATYPE_BLOCKLIST = ['EXT_SMS_ANALYZE_TIME_SERIES'];
const isSnowflakeComparisonReport = report => {
  var _getIn;
  return !!((_getIn = report.getIn(['reportDefinition', 'dateComparisonFilter'])) !== null && _getIn !== void 0 && _getIn.length);
};
export const showDatawellInsight = previewReport => {
  if (isJourneyReport(previewReport)) {
    return true;
  } else if (isReportValidForReportGetterStrategy(previewReport)) {
    const chartType = getStandardFieldType(previewReport, STANDARD_FIELD_TYPES.CHART_TYPE);
    const metrics = getStandardFieldType(previewReport, STANDARD_FIELD_TYPES.METRICS);
    if (isConfigReport(previewReport) && isCustomWidgetReport(previewReport)) {
      return hasCustomWidgetKpis(previewReport);
    }
    const dataType = getStandardFieldType(previewReport, STANDARD_FIELD_TYPES.DATA_TYPE);
    if (isUnifiedEventsReport(previewReport) || isUnifiedAnalyticsReport(previewReport) && !UA_SRV_DATAWELL_EXCEPTION_LIST.includes(dataType) || isMultiConfigReport(previewReport) || isFunnelReport(previewReport) || isConfigReport(previewReport) && isSearchReport(previewReport) || isRelationalReport(previewReport) && isSnowflakeComparisonReport(previewReport) || [DATA_WELL, VisualTypes.TEXT, VisualTypes.SCATTER, GAUGE].includes(chartType) || isReportWithExternalDataType(previewReport) && EXTERNAL_DATATYPE_BLOCKLIST.includes(dataType) || metrics.length === 0) {
      return false;
    }
    return true;
  }
  return false;
};
const SRVDatawellInsight = ({
  previewReport,
  appUsageTracker,
  trackingAssetType,
  trackingApplicationName,
  trackingScreenName,
  dataset,
  showAIBuilder,
  reportResolve
}) => {
  const [insightReport] = useState();
  const containerProps = {
    previewReport,
    appUsageTracker,
    trackingAssetType,
    trackingApplicationName,
    trackingScreenName,
    showAIBuilder
  };
  if (!showDatawellInsight(previewReport)) {
    return null;
  }
  const EmptyErrorComponent = () => /*#__PURE__*/_jsx(_Fragment, {});
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    ErrorComponent: EmptyErrorComponent,
    children: /*#__PURE__*/_jsx(SRVDatawellInsightContainer, Object.assign({}, containerProps, {
      insightReport: insightReport,
      children: /*#__PURE__*/_jsx(ReportKPIContent, {
        previewReport: previewReport,
        dataset: dataset,
        reportResolve: reportResolve
      })
    }))
  });
};
export default SRVDatawellInsight;